module.exports = __webpack_public_path__ + "static/media/companynewsImg6.ead1dc1c.jpg";